import {Component, OnInit} from '@angular/core';

import {Permission} from 'src/app/models/permission.model';
import {AppService} from 'src/app/app.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'fx-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.sass'],
})
export class WalletComponent implements OnInit {
  permission: Permission;
  isProEnvi = (environment.name === 'pro');
  constructor(private appService: AppService) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {}
}
